import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { getDmService, updateDmService, getByDmService } from '../../../../../services/Api';
import adminCampaignPromoters from '../../../../../fixtures/adminCampaignPromoters.json';
import OrderHistory from '../../../../../components/agency/requests/OrderHistory';
import DinamicAndBudgets from '../../../../../components/trades/campaign/DinamicsAndBudgts';
import UnitsAndStores from '../../../../../components/campaigns/UnitsAndStores';
import Merchandising from '../../../../../components/trades/campaign/Merchandising';
import NoteCampaign from '../../../../../components/trades/campaign/NoteCampaign';
import PeriodCampaign from '../../../../../components/trades/campaign/PeriodCampaign';


class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFinished: false,
      selectedItemSearch: null,
      selectedUnit: null,
      selectedStore: null,
      stores: [],
      ocorrencias:[],
      dataForm: { Pedido: props.match.params.id },
    };
  }

  componentWillMount = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const nivel = (user.nivel || {}).id;
    this.setState({ nivel });
    this.load();
  }

  load = async() => {
    const {match} = this.props
    const ocorrencias = await getByDmService('/Ocorrencia/pedido', match.params.id);
    this.setState({ocorrencias})
  }

  loadStores = async () => {
    try {
      const data = await getDmService('/Unidade?usaPrecadastro=true');
      const arrStores = [];
      data.map(item => arrStores.push({
        id: item.id,
        label: item.nome,
      }));

      this.setState({
        stores: arrStores,
      });

    } catch (error) {
      console.error(error);
    }
  };

  onChangeUnit = (obj) => {
    this.setState({
      selectedUnit: obj,
      selectedStore: null,
      error: null,
    });

    if (obj) {
      this.loadStores(obj.id);
    }
  };

  onChangeStore = (obj) => {
    this.setState({
      selectedStore: obj,
      error: null,
    });
  };

  changeSelected = (obj) => {
    if (obj) {
      this.setState({ selectedItemSearch: obj, btnReturn: false }, () => {
        this.searchTradeTyped(obj);
      });
    } else {
      this.setState({
        selectedItemSearch: {},
        showResults: false,
      });
    }
  };

  saveStep = (stepData) => {
    console.log("stepData")
    console.log(stepData)
    this.setState(
      prevState => ({
        ...prevState,
        dataForm: {
          ...prevState.dataForm,
          ...stepData,
        },
      }), () => {
        this.saveData()
      },
    );
  };

  saveData = async () => {
    const { data, reloadCampaign } = this.props;
    const { dataForm } = this.state;
    const idItem = data.itensCampanhaPromocional[0].id;

    try {
      await updateDmService('/Pedido/EditaCampanhaPromocional', idItem, dataForm)
      if((dataForm.salvouPeriodo && dataForm.clicked) || !dataForm.salvouPeriodo){
        await toast.success('Edição realizada com sucesso.');        
      }
      await reloadCampaign();
      
    } catch (error) {
      console.log(error)
      toast.error(
        'Um erro inesperado ocorreu ao tentar editar os dados de campanha promocional',
      );
    }
  }

  renderComponent = (step) => {
    const { data, match } = this.props;
    const { nivel } = this.state;
    const {path} = match;
    console.log(nivel)
    let isStore = path === "/trade/campanhas-promocionais/visualizar/:id";
    if(nivel !== 10 && (data.status && data.status.id === 3)) {
      isStore = false;
    }
    console.log(isStore, data.status)
    const validate = true
    const saveUnitAndStore = data && data.itensCampanhaPromocional[0].unidadesLojas.length ? validate : !validate;
    
    switch (step.form) {
      case 'periodo':
        return (
          <PeriodCampaign
            key={step.id}
            step={step}
            campaignItem={data.itensCampanhaPromocional}
            data={data && data.itensCampanhaPromocional[0]}
            saveStep={this.saveStep}
            buttonIn
            isIstore={isStore}
          />
        );

      case 'budget':
        return (
          <DinamicAndBudgets
            key={step.id}
            step={step}
            campaignItem={data && data.itensCampanhaPromocional}
            data={data.itensCampanhaPromocional[0]}
            saveStep={this.saveStep}
            isIstore={isStore}
            buttonIn
          />
        );

      case 'unidades':
        return (
          <UnitsAndStores
            key={step.id}
            step={step}
            campaignItem={data.itensCampanhaPromocional}
            list={
              data.itensCampanhaPromocional.length > 0
              && data.itensCampanhaPromocional[0].unidadesLojas
            }
            showSave={validate}
            titleBtnSave="Avançar"
            saveStep={this.saveStep}
            salvouUnidades={saveUnitAndStore}
            hideActions={false}
            disabled={isStore}
          />
        );

      case 'merchandising':
        return (
          <Merchandising
            key={step.id}
            step={step}
            campaignItem={data.itensCampanhaPromocional}
            data={data && data.itensCampanhaPromocional[0]}
            saveStep={this.saveStep}
            buttonIn
            isStore={isStore}
          />
        );

      case 'observacao':
        return (
          <NoteCampaign
            key={step.id}
            step={step}
            campaignItem={data.itensCampanhaPromocional}
            data={data.itensCampanhaPromocional[0]}
            saveStep={this.saveStep}
            isStore={isStore}
            buttonIn
          />
        );

      default:
        return null;
    }

  };

  render() {
    const {nivel, ocorrencias} = this.state;
    return (
      <div>
        {adminCampaignPromoters.map(item => this.renderComponent(item))}
        <OrderHistory {...this.props} isTrade="true" nivel={nivel} data={ocorrencias} onChange={async () => { await this.load() }} />
      </div>
    )
    ;
  }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Campaign/Detail/Detail.js